import { Button, Container } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../../../utils/ApiClient/apiClientAxios";
import GPTDropzone from "../../../utils/Dropzone";

const ImportConfigComp = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      files.forEach((f) => f.preview && URL.revokeObjectURL(f.preview));
    };
  }, [files]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (files.length === 0) {
      toast.warn("Please upload at least one .json file!");
      return;
    }

    try {
      setLoading(true);
      const jsonArray = await Promise.all(
        files.map(async (pf) => {
          const file = pf.file || pf;
          const text = await file.text();
          try {
            return JSON.parse(text);
          } catch (err) {
            throw new Error(`Invalid JSON in file: ${file.name}`);
          }
        })
      );

      const response = await apiClient.post("/import", jsonArray, {
        headers: { "Content-Type": "application/json" },
        validateStatus: () => true,
      });

      console.log("Response:", response.data);

      if (response.status === 200) {
        toast.success(
          `✅ Uploaded ${jsonArray.length} JSON file(s) successfully.`
        );
      } else if (response.status === 207) {
        let errors = [];

        let data = response.data;

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch {
            console.warn("Could not parse backend response as JSON:", data);
            data = {};
          }
        }

        if (Array.isArray(data.errors)) {
          errors = data.errors;
        } else if (typeof data.errors === "string") {
          try {
            errors = JSON.parse(data.errors);
          } catch {
            errors = [data.errors];
          }
        }

        if (errors.length > 0) {
          errors.forEach((err) => {
            toast.error(`⚠️ ${err}`, { autoClose: 7000 });
          });
        } else {
          toast.info(
            `⚠️ ${data?.message || "Partial upload with unknown issues"}`
          );
        }
      }

      setFiles([]);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(`❌ Upload error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="container.xl" py={10}>
      <form onSubmit={handleSubmit}>
        <GPTDropzone
          accept={{ "application/json": [".json"] }}
          uploadLabel="Drop your JSON files here or click to browse"
          hintText="You can upload one or more .json files."
          multiple={true}
          files={files}
          onChange={setFiles}
        />
        <Button
          type="submit"
          variant="secondary"
          w="63%"
          mt={2}
          isLoading={loading}
        >
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default ImportConfigComp;
